export default function convertToKebabCase(value: string): string {
    return value?.toLowerCase().replaceAll(" ", "-")
}
